// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Api from "../../core/Api.js";
import * as Buhta_landing__Content from "../../core/Content.js";
import * as Buhta_landing__Link from "../../components/html/Link.js";
import * as Buhta_models__Locale from "../../../../../packages/models/Locale.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LibrarySearch(Props) {
  let query = Props.query;
  let clearQuery = Props.clearQuery;
  let language = Props.language;
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const pages = match[0].librarySearch;
  React.useEffect((function () {
    if (query !== "") {
      const __x = Buhta_landing__Api.librarySearch(query, Buhta_models__Locale.toString(language));
      $$Promise.get(__x, (function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }));
    }
    
  }), [
    query,
    language
  ]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h6", {
        children: "Результаты поиска по запросу \"" + query + "\"",
        className: "h6 text-black-landing mt-6 lg:mt-10"
      }),
      Belt__Belt_List.toArray(Stdlib__List.map((function (page) {
        const Key = page.id;
        return JsxRuntime.jsx(Buhta_landing__Link.make, {
          route: {
            TAG: /* Landing */ 0,
            _0: /* COUNTRY_KAZ */ 1,
            _1: language,
            _2: {
              TAG: /* LibraryArticle */ 6,
              _0: page.slug
            }
          },
          className: "paragraph text-primary underline mt-4 block",
          onLinkClicked: clearQuery,
          children: page.title
        }, Key);
      }), pages))
    ],
    className: "lg:w-200 px-6 sm:px-48 lg:px-0"
  });
}

const make = LibrarySearch;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
